import { render, staticRenderFns } from "./ProtocolsCompleted.vue?vue&type=template&id=6dfc7b33"
import script from "./ProtocolsCompleted.vue?vue&type=script&lang=js"
export * from "./ProtocolsCompleted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports